import styled from '@emotion/styled';

import { SyntheticEvent, useState } from 'react';

import { css } from '@emotion/react';

import { NoMainImageLogo } from '../../../../shared/images';
import COLOR from '../../../../shared/constant/colorset';

const Container = styled.a<{ isError: boolean; }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 175px;
  height: 175px;
  outline: none;
  ${({ isError }) => isError &&
    css`
      background-color: ${COLOR.kurlyGray150};
    `}
`;

const Image = styled.img<{ isError: boolean; }>`
  ${({ isError }) => isError ?
    css`
      width: 80px;
      object-fit: cover;
      aspect-ratio: 1;
    ` :
    css`
      width: 100%;
      height: 100%;
      object-fit: cover;
      aspect-ratio: 1;
    `}
`;

interface Props {
  src: string;
  href: string;
}

export default function InstagramReviewItem({ src, href }: Props) {
  const [isError, setIsError] = useState(false);

  const handleImgError = (e: SyntheticEvent<HTMLImageElement, Event>) => {
    setIsError(true);
    e.currentTarget.src = NoMainImageLogo;
  };

  return (
    <Container
      href={href}
      isError={isError}
    >
      <Image
        src={src}
        alt="인스타그램 리뷰 사진"
        isError={isError}
        onError={handleImgError}/>
    </Container>
  );
}
